module.exports = __webpack_public_path__ + "img/138.5fc9a229.jpg";